/* eslint-disable */
import * as Types from '../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type OrganisationMembershipInvitationEmailForm_TemplateFragment = { __typename: 'OrganisationEmailTemplate', id: string, description: string, subject: string, content: string };

export type OrganisationMembershipInvitationEmailTemplatesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type OrganisationMembershipInvitationEmailTemplatesQuery = { organisationEmailTemplates: { __typename: 'MissingCapabilities' } | { __typename: 'MissingPermissions' } | { __typename: 'OrganisationEmailTemplatesResult', emailTemplates: Array<{ __typename: 'OrganisationEmailTemplate', id: string, description: string, subject: string, content: string }> } };

export const OrganisationMembershipInvitationEmailForm_TemplateFragmentDoc = gql`
    fragment OrganisationMembershipInvitationEmailForm_Template on OrganisationEmailTemplate {
  id
  description
  subject
  content
}
    `;
export const OrganisationMembershipInvitationEmailTemplatesDocument = gql`
    query OrganisationMembershipInvitationEmailTemplates {
  organisationEmailTemplates(forContext: MEMBER) {
    ... on OrganisationEmailTemplatesResult {
      emailTemplates {
        ...OrganisationMembershipInvitationEmailForm_Template
      }
    }
  }
}
    ${OrganisationMembershipInvitationEmailForm_TemplateFragmentDoc}`;

/**
 * __useOrganisationMembershipInvitationEmailTemplatesQuery__
 *
 * To run a query within a React component, call `useOrganisationMembershipInvitationEmailTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganisationMembershipInvitationEmailTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganisationMembershipInvitationEmailTemplatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrganisationMembershipInvitationEmailTemplatesQuery(baseOptions?: Apollo.QueryHookOptions<OrganisationMembershipInvitationEmailTemplatesQuery, OrganisationMembershipInvitationEmailTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganisationMembershipInvitationEmailTemplatesQuery, OrganisationMembershipInvitationEmailTemplatesQueryVariables>(OrganisationMembershipInvitationEmailTemplatesDocument, options);
      }
export function useOrganisationMembershipInvitationEmailTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganisationMembershipInvitationEmailTemplatesQuery, OrganisationMembershipInvitationEmailTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganisationMembershipInvitationEmailTemplatesQuery, OrganisationMembershipInvitationEmailTemplatesQueryVariables>(OrganisationMembershipInvitationEmailTemplatesDocument, options);
        }
export function useOrganisationMembershipInvitationEmailTemplatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrganisationMembershipInvitationEmailTemplatesQuery, OrganisationMembershipInvitationEmailTemplatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrganisationMembershipInvitationEmailTemplatesQuery, OrganisationMembershipInvitationEmailTemplatesQueryVariables>(OrganisationMembershipInvitationEmailTemplatesDocument, options);
        }
export type OrganisationMembershipInvitationEmailTemplatesQueryHookResult = ReturnType<typeof useOrganisationMembershipInvitationEmailTemplatesQuery>;
export type OrganisationMembershipInvitationEmailTemplatesLazyQueryHookResult = ReturnType<typeof useOrganisationMembershipInvitationEmailTemplatesLazyQuery>;
export type OrganisationMembershipInvitationEmailTemplatesSuspenseQueryHookResult = ReturnType<typeof useOrganisationMembershipInvitationEmailTemplatesSuspenseQuery>;
export type OrganisationMembershipInvitationEmailTemplatesQueryResult = Apollo.QueryResult<OrganisationMembershipInvitationEmailTemplatesQuery, OrganisationMembershipInvitationEmailTemplatesQueryVariables>;